import React, { useEffect, useState, useCallback } from 'react';

import { retrieveAllStaffMembers } from '../../../../services/StaffMemberService';

import { Table } from '../../../common/table/Table';

import './UsersSearch.css';

export const UsersSearch = ({ setSpinnerText, context, showToaster, navigateToWith }) => {
  const [searchResults, setSearchResults] = useState([]);

  const retrieveAllUsers = useCallback(async () => {
    setSpinnerText('Retrieving Users');
    const [data, error] = await retrieveAllStaffMembers(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        setSearchResults(data.systemUserVOList);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  }, [context.username, setSpinnerText, showToaster]);

  useEffect(() => {
    retrieveAllUsers();
  }, [retrieveAllUsers]);

  const handleRowClick = (user) => {
    navigateToWith('usersView', 'userGeneral', user);
  };

  return (
    <div className="users-search">
      {searchResults && (
        <Table
          tableData={searchResults}
          filterEnabled={true}
          tableTitle={'Users'}
          onRowClick={handleRowClick}
          searchEnabled={true}
          maxRowCount={10}
          hiddenColumns={[
            'externalReference',
            'created',
            'sites',
            'isDeleted',
            'lastModified',
            'cellphoneNumber',
            'toolTipsEnabled',
            'lastActivity',
            'personExternalReference',
          ]}
          horizontalScroll
        />
      )}
    </div>
  );
};
